export default __webpack_public_path__ + "static/media/carbon_delivery.e4005b86.svg";